import { getReasonPhrase } from "http-status-codes";

export const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZone: "UTC",
  });
};

export const trimText = (text: string, length: number) => {
  if (text.length > length) {
    return `${text.substring(0, length)}...`;
  }
  return text;
};

export const formatNumber = (digit: number) => {
  return digit ? digit.toLocaleString("en-US") : null;
};

export const changeObjectToURLParams = (
  data: { [key: string]: string },
  options: { skip?: string[]; isEndWithAmp?: boolean } = {}
) => {
  const { skip = [], isEndWithAmp = true } = options;

  return Object.keys(data)
    .filter((key) => !skip.includes(key))
    .map(
      (key) =>
        `${!isEndWithAmp ? "&" : ""}${key}=${data[key]}${
          isEndWithAmp ? "&" : ""
        }`
    )
    .join("");
};

export const changeFormDataToURLParams = (formData: FormData) => {
  const params: string[] = [];

  formData.forEach((value, key) => {
    value && params.push(`${key}=${value}&`);
  });

  return params.join("");
};

export const getHttpStatusDescription = (status: number | string) => {
  return getReasonPhrase(status);
};

export const getNameInitials = (name?: string | null) => {
  return name
    ?.split(" ")
    ?.map((n) => n[0])
    ?.join("");
};

export const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
